import { useMemo } from 'react';
import { BottomActionBarV2, DialogV2, AritoIcon, AritoFormV2 } from '@/components/custom/erp';
import { useAccountFormContext, useAccountPageContext } from '../context';
import { ConstraintsTab, GeneralTab } from './tabs';
import { FormSchema } from '../schemas';
import { BasicInfoTab } from '.';

const getDialogTitle = (mode: 'add' | 'edit' | 'view') => {
  switch (mode) {
    case 'add':
      return 'Mới';
    case 'edit':
      return 'Sửa';
    default:
      return 'Xem';
  }
};

interface FormDialogProps {
  zIndex?: number;
}

const FormDialog = ({ zIndex }: FormDialogProps = {}) => {
  const form = useAccountFormContext();
  const page = useAccountPageContext();
  const tabs = useMemo(
    () => [
      {
        id: 'general_tab',
        label: 'Thông tin chung',
        component: <GeneralTab />
      },
      {
        id: 'constraints_tab',
        label: 'Ràng buộc',
        component: <ConstraintsTab />
      }
    ],
    []
  );

  return (
    <>
      <DialogV2
        open={true}
        onClose={form.handleRequestClose}
        title={getDialogTitle(form.mode)}
        maxWidth='xl'
        disableBackdropClose={false}
        disableEscapeKeyDown={true}
        titleIcon={<AritoIcon icon={281} />}
        zIndex={zIndex}
      >
        <AritoFormV2
          mode={form.mode}
          hasAritoActionBar={false}
          schema={FormSchema}
          onSubmit={form.handleSubmit}
          onClose={form.handleRequestClose}
          initialData={form.initialValues}
          className='w-[840px]'
          headerFields={
            <div className='max-h-[calc(100vh-150px)] overflow-y-auto'>
              <BasicInfoTab />
            </div>
          }
          tabs={tabs}
          bottomBar={
            <BottomActionBarV2
              mode={form.mode}
              onSubmit={() => {}}
              onClose={form.handleRequestClose}
              onAdd={form.mode === 'view' ? page.handleOpenAdd : undefined}
              onEdit={form.mode === 'view' ? page.handleOpenEdit : undefined}
              onDelete={form.mode === 'view' ? page.handleRequestDelete : undefined}
              onCopy={form.mode === 'view' ? page.handleOpenCopy : undefined}
            />
          }
        />
      </DialogV2>
    </>
  );
};

export default FormDialog;
